import { themeStore } from "stores/themes";
import { partition } from "lodash";

let isFetching = false;

export const fetchFavourites = async () => {
  if (isFetching) return false;
  if (typeof App === 'undefined' || !App.order.logged_in()) return false;

  isFetching = true;
  try {
    await themeStore.some();
    const [favourited] = partition(themeStore.themes, 'favourite');

    return favourited;
  } finally {
    isFetching = false;
  }
};
